import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
import zh from './i18n/zh-TW.json'
import ja from './i18n/ja-JP.json'
import en from './i18n/en-US.json'
import '@mdi/font/css/materialdesignicons.css'
import * as signalR from '@microsoft/signalr'
import VueApexCharts from 'vue-apexcharts'

Vue.use(signalR)
Vue.use(VueI18n)
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts)

// const userId = JSON.parse(store.state.user).userId
// console.log(JSON.parse(store.state.user))
// Vue.prototype.signalR = new signalR.HubConnectionBuilder()
//     .withAutomaticReconnect()
//     .withUrl('http://localhost:9999/message?userName=' + userId, {})
//     .build()
const locale = store.state.lang
const i18n = new VueI18n({
  locale: locale,
  globalInjection: true,
  fallbackLocale: 'zh-TW',
  messages: {
    'zh-TW': zh,
    'ja-JP': ja,
    'en-US': en
  }
})

Vue.config.productionTip = false
if (navigator.platform.includes('Win')) {
  require('@/windowsFont.css')
}

new Vue({
  router,
  vuetify,
  store,
  i18n,
  signalR,
  render: h => h(App)
}).$mount('#app')
 
router.beforeEach((to, from, next) => {
  var isLogin = false
  // console.log(store.state.token)
  store.state.token !== '' ? isLogin = true : isLogin = false
  if (isLogin) {
    next()
  } else {
    if (to.path !== '/Login') {
      next('/Login')
    } else {
      next()
    }
  }
})
